import { Form, media } from 'ia-react-core';
import styled from 'styled-components';

export const StyledLabel = styled.label`
  font-size: ${({ theme }) => theme.fontSize.base}px;
  display: flex;
  font-weight:  bold;
  margin-bottom: 12px;
  width: 100%;
`;
export const StyledDropDown = styled(Form)`
  padding: 0px 0px 24px 0px;
  display: grid;
  ${media.sm`
  width: 40%;
  `}
`;
